import {
  Activity,
  AtSign,
  BellRing,
  CircleAlert,
  ClipboardCheck,
  UserCheck,
  type LucideIcon,
} from "lucide-react";
import type {
  NotificationClass,
  NotificationItem,
  NotificationTone,
} from "@playbookai/types";
import { labelForModule } from "../notifications/notification-event-labels.js";

export interface NotificationCategory {
  readonly value: NotificationClass;
  readonly label: string;
  readonly icon: LucideIcon;
}

export const NOTIFICATION_CATEGORIES: readonly NotificationCategory[] = [
  { value: "mention", label: "Mentions", icon: AtSign },
  { value: "approval", label: "Approvals", icon: ClipboardCheck },
  { value: "assignment", label: "Assignments", icon: UserCheck },
  { value: "escalation", label: "Escalations", icon: CircleAlert },
  { value: "activity", label: "Activity", icon: Activity },
  { value: "informational", label: "Information", icon: BellRing },
];

export const TONE_ICON: Record<NotificationTone, string> = {
  red: "bg-pb-red-soft text-pb-red-text ring-pb-red/25",
  amber: "bg-pb-amber-soft text-pb-amber-text ring-pb-amber/25",
  teal: "bg-pb-teal-soft text-pb-teal-text ring-pb-teal/25",
  cyan: "bg-pb-cyan-soft text-pb-cyan-text ring-pb-cyan/25",
};

export function categoryOf(item: NotificationItem): NotificationClass {
  return item.class ?? "informational";
}

export function categoryLabel(value: NotificationClass): string {
  return (
    NOTIFICATION_CATEGORIES.find((category) => category.value === value)
      ?.label ?? "Information"
  );
}

export function categoryIcon(value: NotificationClass): LucideIcon {
  return (
    NOTIFICATION_CATEGORIES.find((category) => category.value === value)
      ?.icon ?? BellRing
  );
}

export function notificationModuleLabel(item: NotificationItem): string {
  return item.moduleId == null ? "Platform" : labelForModule(item.moduleId);
}

export function matchesNotificationSearch(
  item: NotificationItem,
  query: string,
): boolean {
  const normalized = query.trim().toLowerCase();
  if (!normalized) return true;
  return `${item.title} ${item.description} ${notificationModuleLabel(item)} ${categoryLabel(categoryOf(item))}`
    .toLowerCase()
    .includes(normalized);
}
